import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function LogoutIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    d: "M17 9V11H11V13H17V15L21 12L17 9Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    d: "M6 2H15V4H5.99999C5.44872 4 4.99999 4.44873 4.99999 5V19C4.99999 19.5513 5.44872 20 5.99999 20H15V22H6C4.3457 22 3 20.6543 3 19V5C3 3.3457 4.3457 2 6 2Z",
    fill: "currentColor"
  }));
}